import axios from '@/util/request'


//GET /sys/sys-area/getCityList
// 查询城市
export const getCityList = (params) => {
    return axios({
        url: '/com/sys/sys-area/getCityList',
        method: 'get',
        params
    })
}

//GET /sys/sys-area/getCountyList
//查询区县
// GET /com/sys/sys-area/getCountyList
export const getCountyList = (params) => {
    return axios({
        url: '/com/sys/sys-area/getCountyList',
        method: 'get',
        params
    })
}

//GET /sys/sys-area/getProvinceList
//查询所有省份
export const getProvinceList = (params) => {
    return axios({
        url: '/com/sys/sys-area/getProvinceList',
        method: 'get',
        params,
        noLoading: true
    })
}

// /com/file/fileDownLoad
// 文件下载或预览
export const fileDownLoad = (params) => {
    return axios({
        url: '/com/file/fileDownLoad',
        method: 'get',
        params
    })
}


// /coms/dict/getDictListByPid
// 根据code获取数据字典列表(不传pid则查询全部)
export const getDictListByPid = (params) => {
    return axios({
        url: '/com/dict/getDictListByPid',
        method: 'get',
        params
    })
}